import { PrinterOutlined } from '@ant-design/icons';
import { Button, Divider, Form, Row, Space, Table, Typography } from 'antd';
import React from 'react';
import { Localization, _T } from '../../../../../base-react/src/Localization';
import { useParams } from 'react-router-dom';
import { hooks, models } from '@vote4dance/judging-sdk';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { Loading } from '../../../../../base-react/components/Loading';
import { PrintStartNumberHeader } from '../../teams/components/PrintStartNumber';
import { RoundPathParent } from '../../../../components/RoundPathParent';
import { JudgeType } from '@vote4dance/judging-schema';
var Stream = hooks.streams.Stream;
var RoundItem = models.rounds.RoundItem;
var HeatSource = models.heats.HeatSource;
var HeatsTeamSource = models.teams.HeatsTeamSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
const { Title, Text } = Typography;
export const PrintJudgingSheet = () => {
    const { competition_id, class_id, round_id } = useParams();
    const [inputCompetition, event, , loadingCompetition] = useCompetition(competition_id);
    const [heats, loadingHeats] = Stream(HeatSource(round_id));
    const [rounds, loadingRounds] = Stream(ClassRoundSource(class_id));
    if (loadingCompetition || loadingHeats || loadingRounds) {
        return React.createElement(Loading, null);
    }
    const foundRound = rounds && rounds.find((a) => a.round_id === round_id);
    if (!foundRound) {
        return null;
    }
    document.title = `${event === null || event === void 0 ? void 0 : event.competition_date}_${event === null || event === void 0 ? void 0 : event.competition_name}_${RoundItem.getClassLabel(foundRound)}_${foundRound.round_label}_judging-sheet`;
    const submitValidation = RoundItem.getSubmitValidation(foundRound);
    const components = foundRound.judging_components ? JSON.parse(foundRound.judging_components) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement("style", { type: "text/css", media: "print" }, `@page { size: portrait; margin: 0 !important }
                  .judging-sheet .ant-table-cell { padding: 2px 6px !important; }
                  .judging-sheet .ant-table-thead > tr > th { padding: 2px 6px !important; }
                  .judging-sheet .ant-table-tbody > tr > td { vertical-align: top; }
                  .judging-sheet-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 24px; }
                  .judging-sheet-block { break-inside: avoid; page-break-inside: avoid; }
                `),
        React.createElement(PrintJudgingSheetSettings, null),
        React.createElement("div", { style: { margin: 24 } },
            React.createElement(PrintStartNumberHeader, { event: event, competition: inputCompetition, style: { height: 'inherit' } }),
            React.createElement(Space, { orientation: 'vertical', style: { width: '100%' }, size: "small" },
                React.createElement(RoundPathParent, { record: foundRound }, (round, parents) => React.createElement(Title, { level: 5 },
                    React.createElement(Space, { wrap: true, separator: React.createElement(Divider, { orientation: 'vertical' }), size: 'small' },
                        (round.round_beat || round.floor_code) && React.createElement("span", null,
                            round.round_beat,
                            round.floor_code),
                        RoundItem.getClassLabel(round),
                        parents ? parents.map((parent, index) => React.createElement("div", { key: index }, RoundItem.getRoundLabel(parent))) :
                            RoundItem.getRoundLabel(round)))),
                React.createElement(Space, { size: "large" },
                    React.createElement(Text, { strong: true }, _T('judges.title')),
                    React.createElement("div", { style: { borderBottom: '1px solid #000', minWidth: 180, height: 16 } })),
                foundRound.round_comment && (React.createElement(Text, null, foundRound.round_comment)),
                React.createElement(Space, { orientation: "vertical", size: "small" },
                    foundRound.judge_type && foundRound.judge_type != JudgeType.Normal && (React.createElement(Text, { strong: true },
                        _T('judges.type.label'),
                        React.createElement(Text, { strong: true }, _T(`judges.type.${foundRound.judge_type}.title`)))),
                    foundRound.round_num_through > 0 && (React.createElement(Text, { strong: true },
                        _T('round.details.round_num_through.label'),
                        React.createElement("strong", null,
                            foundRound.round_num_through,
                            "/",
                            foundRound.round_count))),
                    submitValidation && (React.createElement(Text, { strong: true },
                        React.createElement(Space, null,
                            _T('round.details.round_submit_validation.label'),
                            submitValidation.map((rule) => (React.createElement(Text, { key: rule[0] },
                                rule[0],
                                ": ",
                                React.createElement(Text, { strong: true }, rule[1]))))))),
                    foundRound.acro_id != null && (React.createElement(Text, { strong: true },
                        _T('round.details.acro_id.label'),
                        " ",
                        React.createElement("strong", null, foundRound.acro_name))),
                    foundRound.judging_label && (React.createElement(Text, { strong: true }, Localization.getLocalizedString(JSON.parse(foundRound.judging_label)))),
                    (components === null || components === void 0 ? void 0 : components.components) && components.components.length > 1 && (React.createElement(Space, { separator: !components.components.some((a) => a.description) && React.createElement(Divider, { orientation: "vertical" }), size: "small", wrap: true, direction: components.components.some((a) => a.description) ? 'vertical' : 'horizontal' }, components.components.map((component) => (React.createElement(Text, { key: component.id },
                        React.createElement(Text, { strong: true }, Localization.getLocalizedString(component.name)),
                        ' ',
                        Localization.getLocalizedString(component.description))))))),
                React.createElement("div", { className: "judging-sheet-grid" }, heats && heats.map(heat => (React.createElement(PrintJudgingHeat, { key: heat.heat_number, heat: heat, round_id: round_id, totalHeats: heats.length }))))))));
};
const PrintJudgingSheetSettings = () => {
    const onFinish = () => {
        window.print();
    };
    return (React.createElement(Row, { style: { width: '100%', paddingLeft: 30, backgroundColor: 'lightgrey' } },
        React.createElement("div", { className: "settings" },
            React.createElement("style", null, `@media print {.settings{display: none;}}`),
            React.createElement(Title, null, _T('common.print', { name: _T('judges.title').toLowerCase() })),
            React.createElement(Form, { name: "printsettings", labelCol: { span: 8 }, wrapperCol: { span: 16 }, style: { maxWidth: 600 }, onFinish: onFinish, autoComplete: "off" },
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Button, { icon: React.createElement(PrinterOutlined, null), type: "primary", htmlType: "submit" }, _T('common.print')))))));
};
const PrintJudgingHeat = (props) => {
    const { heat, round_id, totalHeats } = props;
    const [teams, loadingTeams] = Stream(HeatsTeamSource(round_id, heat.heat_number));
    if (loadingTeams) {
        return null;
    }
    const heatTitle = `${_T('round.heat', { number: heat.heat_number })}/${totalHeats} (${(teams === null || teams === void 0 ? void 0 : teams.length) || 0})`;
    return (React.createElement("div", { className: "judging-sheet-block" },
        React.createElement(Table, { className: "judging-sheet", dataSource: teams, pagination: false, rowKey: "heats_team_id", bordered: true, columns: [
                {
                    title: heatTitle,
                    dataIndex: 'team_start_number',
                    key: 'team_start_number',
                    align: 'center',
                    width: 70,
                    onHeaderCell: () => ({ colSpan: 3 }),
                    render: (value, item) => (item.team_cancelled
                        ? React.createElement("del", { style: { fontSize: 14, lineHeight: '18px', display: 'inline-block' } }, value)
                        : React.createElement("span", { style: { fontSize: 14, lineHeight: '18px', display: 'inline-block' } }, value))
                },
                {
                    title: '',
                    key: 'mark',
                    width: 80,
                    onHeaderCell: () => ({ colSpan: 0 }),
                    render: () => null
                },
                {
                    title: '',
                    key: 'comment',
                    onHeaderCell: () => ({ colSpan: 0 }),
                    render: () => null
                }
            ] })));
};
